import { render, staticRenderFns } from "./PercentBar.ts.vue?vue&type=template&id=765446e8&"
import script from "./PercentBar.ts.vue?vue&type=script&lang=ts&"
export * from "./PercentBar.ts.vue?vue&type=script&lang=ts&"
import style0 from "./PercentBar.ts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports